import { RestClient } from "./rest-client";

const BACKEND_URL = import.meta.env.VITE_APIGEE_URL;
const BASE_URL_LOG = `${BACKEND_URL}onboarding-api/v1/onboardings/log`;

export enum LOG_LEVELS {
  INFO = "INFO",
  WARNING = "WARNING",
  ERROR = "ERROR",
  DEBUG = "DEBUG",
  TRACE = "TRACE",
}

export const SendLog = async (
  level: LOG_LEVELS,
  ...messages: string[]
): Promise<boolean> => {
  try {
    await RestClient.request<any>({
      method: "post",
      url: `${BASE_URL_LOG}`,
      data: {
        level,
        message: messages.join(" "),
      },
      excludeHeaders: ["obTraceId"],
      ignoreErrors: true,
    });
    return true;
  } catch (error) {
    console.warn("Error trying to create a log entry", error);
    return false;
  }
};
